import { ComponentProps, forwardRef } from 'react';

import isNumber from 'lodash/isNumber';

import cx from 'classnames';

import { TColors, TSizesExtended } from '../../types';

import { TIconImages } from './codegen/types';
import styles from './Icon.module.scss';

export type { TIconImages };

export type TIconRotate = '90' | '180' | '270';

export type TIconProps = {
  color?: TColors;
  img: TIconImages;
  rotate?: TIconRotate;
  size?: TSizesExtended | number;
  type?: 'flat' | 'colored';
} & ComponentProps<'div'>;

export const Icon = forwardRef<HTMLDivElement, TIconProps>(function Icon(
  { className, color, img, rotate, size = 'm', type = 'flat', ...rest },
  ref,
) {
  const isCustomSize = isNumber(size);
  const customSizeStyle = isCustomSize
    ? { width: size, height: size, backgroundSize: size, maskSize: size }
    : {};

  return (
    <div
      className={cx(
        className,
        styles.icon,
        styles['type__' + type],
        !isCustomSize && styles['size__' + size],
        styles[img],
        rotate && styles['rotate-' + rotate],
        type === 'flat' && color && styles['bg-' + color],
      )}
      ref={ref}
      style={customSizeStyle}
      {...rest}
    />
  );
});
